import React from 'react';
import Slider from 'react-slick';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { styled } from '@mui/system';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

// Estilos personalizados para el contenedor del carrusel
const CarouselContainer = styled('div')({
  width: '100%',
  margin: 'auto',
//   padding: '2rem 0',
//   backgroundColor: 'var(--bodyColor)',
});

const StyledCard = styled(Card)({
  backgroundColor: 'var(--blackColor)',
  borderRadius: '10px',
//   boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  color: 'var(--whiteColor)',
  textAlign: 'left',
  padding: '1rem',
  position: 'relative',
  overflow: 'visible',
  minHeight: '200px',
});

const ImageContainer = styled('div')({
    position: 'absolute',
    top: '0px',
    right: '35px',
    width: '200px',
    height: '200px',
    borderRadius: '50%',
    overflow: 'hidden',
    border: '4px solid var(--PrimaryColor)',
    // boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
});

const Image = styled('img')({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
});

const Testimonials = ({testimonials}) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: false,
  };

  return (
    <CarouselContainer>
      <Slider {...settings}>
        {testimonials.map((testimonial, index) => (
          <StyledCard key={index}>
            <ImageContainer>
                <Image src={testimonial.avatar} />
            </ImageContainer>
            <CardContent>
              <Typography variant="body1" component="p" color="var(--whiteColor)" mr={25}>
                {testimonial.testimony}
              </Typography>
              <Box mt={2}>
                <Typography variant="h6" component="div" color="var(--PrimaryColor)">
                  {testimonial.name}
                </Typography>
                <Typography variant="body2" color="var(--greyText)">
                  {testimonial.role}
                </Typography>
              </Box>
            </CardContent>
          </StyledCard>
        ))}
      </Slider>
    </CarouselContainer>
  );
};

export default Testimonials;
